
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8jd70", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7c036e2f32f4f407$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");
var $aLJ1L = parcelRequire("aLJ1L");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9F3VB = parcelRequire("9F3VB");

var $dyvFQ = parcelRequire("dyvFQ");

var $iqtgH = parcelRequire("iqtgH");

var $21igx = parcelRequire("21igx");

var $aWMnb = parcelRequire("aWMnb");

var $bqs8h = parcelRequire("bqs8h");

var $5ZkD9 = parcelRequire("5ZkD9");

var $5Iesg = parcelRequire("5Iesg");

var $173Wl = parcelRequire("173Wl");

var $lqBEF = parcelRequire("lqBEF");

var $8rSHB = parcelRequire("8rSHB");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c036e2f32f4f407$var$PluggableItems = ()=>{
    const [fetchData, { loading: loading, error: error, data: data }] = (0, $21igx.usePluggableItemsQuery)();
    const [isAnyAppLoading] = (0, $9F3VB.useIsAnyAppLoading)();
    const [, { closeApps: closeApps }] = (0, $9F3VB.useForgeApps)();
    const totalCount = data?.length ?? 0;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const allIds = (0, $eJOHy.useMemo)(()=>data?.map((item)=>item?.id) ?? [], [
        data
    ]);
    const registerModalDialogAnalytics = (0, $aWMnb.useRegisterModalDialogAnalytics)();
    (0, $aWMnb.useModalDialogCleanupEffect)();
    (0, $aWMnb.useInlineDialogZIndexOverrideLayoutEffect)();
    // Close the dropdown when all Forge apps are loaded.
    // In practice it will be a single app at a time, but we can't rely on that.
    (0, $eJOHy.useEffect)(()=>{
        if (!isAnyAppLoading) setIsOpen(false);
    }, [
        isAnyAppLoading
    ]);
    // Close all Forge apps when the data is re-fetched
    (0, $eJOHy.useEffect)(()=>{
        (async ()=>{
            await closeApps();
        })();
    }, [
        data,
        closeApps
    ]);
    const onOpenChange = (0, $eJOHy.useCallback)((attrs)=>{
        // Ignore events originating from a matching iframe or an element inside an iframe
        const eventTarget = attrs.event?.target;
        if (eventTarget && eventTarget instanceof HTMLElement && (0, $8rSHB.isInOrIsIFrame)(eventTarget, allIds)) return;
        if (attrs.isOpen) {
            if (!loading) fetchData(error);
            // Only setup analytics when the dialog is opened
            registerModalDialogAnalytics();
        }
        setIsOpen(attrs.isOpen);
    }, [
        allIds,
        error,
        fetchData,
        loading,
        registerModalDialogAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isLoading: loading,
        testId: "issue-navigator-action-pluggable-items.ui.filter-button",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $173Wl.PluggableItemsFilterButton), {
                ...props,
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        spacing: "compact",
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7c036e2f32f4f407$var$containerStyles
    }, !error && totalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, data?.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ZkD9.DropdownItemWithApps), {
            key: item.id,
            item: item,
            totalCount: totalCount
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7c036e2f32f4f407$var$maxWidthContainerStyles,
        role: "menuitem"
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        pageAction: "apps",
        onRetry: ()=>fetchData(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "errorDropdown",
        actionSubjectId: "issueNavigatorActionsPluggableItems"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Iesg.Empty), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lqBEF.IssueNavigatorActionRuntimeContainer), null));
};
const $7c036e2f32f4f407$var$PluggableItemsWithForge = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9F3VB.ForgeAppsContainer), {
        scope: "issue-navigator-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c036e2f32f4f407$var$PluggableItems, null));
var $7c036e2f32f4f407$export$2e2bcd8739ae039 = $7c036e2f32f4f407$var$PluggableItemsWithForge;
const $7c036e2f32f4f407$var$containerStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $bqs8h.ACTIONS_MIN_WIDTH)}px`
});
const $7c036e2f32f4f407$var$maxWidthContainerStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $bqs8h.CONTAINER_MIN_WIDTH)}px`
});

});
parcelRegister("9F3VB", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsContainer", () => $590cae63d5fa5058$export$9d26afcb39445b8e);
$parcel$export(module.exports, "useForgeApps", () => $590cae63d5fa5058$export$a48819842c5a2f15);
$parcel$export(module.exports, "useIsAppLoading", () => $590cae63d5fa5058$export$24db0add8de543af);
$parcel$export(module.exports, "useIsAnyAppLoading", () => $590cae63d5fa5058$export$f65d61db50b49f3);

var $aXKmr = parcelRequire("aXKmr");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $590cae63d5fa5058$export$9d26afcb39445b8e = (0, $6E16M.createContainer)();
const $590cae63d5fa5058$var$actions = {
    openApp: (appId, extension, action, extensionData = {})=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: [
                    ...openedApps.filter((app)=>app.id !== appId || app.action !== action),
                    {
                        id: appId,
                        extension: extension,
                        extensionData: extensionData,
                        action: action,
                        uuid: (0, $aXKmr.v4)(),
                        isLoading: true
                    }
                ]
            });
        },
    setAppLoaded: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.map((app)=>app.id === appId && app.action === action && app.isLoading ? {
                        ...app,
                        isLoading: false
                    } : app)
            });
        },
    closeApps: ()=>({ setState: setState })=>{
            setState({
                openedApps: []
            });
        },
    closeApp: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.filter((app)=>app.id !== appId || app.action !== action)
            });
        }
};
const $590cae63d5fa5058$var$Store = (0, $GtRbT.createStore)({
    containedBy: $590cae63d5fa5058$export$9d26afcb39445b8e,
    initialState: {
        openedApps: []
    },
    actions: $590cae63d5fa5058$var$actions
});
const $590cae63d5fa5058$export$a48819842c5a2f15 = (0, $iJq0l.createHook)($590cae63d5fa5058$var$Store);
const $590cae63d5fa5058$var$isAppLoading = (state, { appId: appId, action: action })=>{
    return state.openedApps.some((app)=>app.id === appId && app.action === action && app.isLoading);
};
const $590cae63d5fa5058$export$24db0add8de543af = (0, $iJq0l.createHook)($590cae63d5fa5058$var$Store, {
    selector: $590cae63d5fa5058$var$isAppLoading
});
const $590cae63d5fa5058$var$isAnyAppLoading = (state)=>state.openedApps.some((app)=>app.isLoading);
const $590cae63d5fa5058$export$f65d61db50b49f3 = (0, $iJq0l.createHook)($590cae63d5fa5058$var$Store, {
    selector: $590cae63d5fa5058$var$isAnyAppLoading
});

});

parcelRegister("21igx", function(module, exports) {

$parcel$export(module.exports, "usePluggableItemsQuery", () => $7ebfaf39895f9303$export$77eee11e2025ce36);

var $eJOHy = parcelRequire("eJOHy");

var $4qiFT = parcelRequire("4qiFT");

var $jGzN3 = parcelRequire("jGzN3");

var $fohjD = parcelRequire("fohjD");

var $dhAnj = parcelRequire("dhAnj");

var $82cqT = parcelRequire("82cqT");

var $fwKw5 = parcelRequire("fwKw5");

var $kEUB1 = parcelRequire("kEUB1");

var $cECwI = parcelRequire("cECwI");

var $2cfd4 = parcelRequire("2cfd4");

var $7jTnu = parcelRequire("7jTnu");

var $gfDeC = parcelRequire("gfDeC");

var $j1JBz = parcelRequire("j1JBz");
const $7ebfaf39895f9303$export$77eee11e2025ce36 = ()=>{
    let pluggableItems;
    let setPluggableItems;
    let lastKeyRef;
    if ((0, $7jTnu.fg)('empanada_nin_convert_apps_to_entrypoint')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const contextValue = (0, $eJOHy.useContext)((0, $gfDeC.PluggableItemsCacheContext));
        pluggableItems = contextValue.pluggableItems;
        setPluggableItems = contextValue.setPluggableItems;
        lastKeyRef = contextValue.lastKeyRef;
    } else {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        [pluggableItems, setPluggableItems] = (0, $eJOHy.useState)({
            ...$7ebfaf39895f9303$export$774a4ee00eaf0f75
        });
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        lastKeyRef = (0, $eJOHy.useRef)(undefined);
    }
    const { jql: jql, filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const locale = (0, $2cfd4.useLocale)();
    const key = !jql && (0, $82cqT.isFilterId)(filterId) ? filterId : jql;
    const currentKeyRef = (0, $eJOHy.useRef)(key);
    const { current: intlCollator } = (0, $eJOHy.useRef)(new Intl.Collator((0, $4qiFT.standardizeLocale)(locale)));
    const fetchPluggableItems = (0, $eJOHy.useCallback)((forceRefetch = false)=>{
        if (forceRefetch || lastKeyRef.current == null || lastKeyRef.current !== currentKeyRef.current) {
            setPluggableItems({
                data: undefined,
                loading: true,
                error: false
            });
            Promise.all([
                (0, $dhAnj.fetchModules)({
                    cloudId: cloudId,
                    isAnonymous: isAnonymous,
                    context: {},
                    types: [
                        (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE)
                    ],
                    includeHidden: false,
                    source: 'issue-navigator'
                }),
                (0, $jGzN3.performPostRequest)('/rest/gira/1/?operation=IssueNavigatorPluggableItemsQuery', {
                    body: JSON.stringify({
                        query: (0, $j1JBz.ISSUE_NAVIGATOR_PLUGGABLE_ITEMS_QUERY),
                        variables: {
                            first: 100
                        }
                    })
                })
            ]).then(([forgeModules, connectResponse])=>{
                if (connectResponse.errors) setPluggableItems({
                    data: null,
                    loading: false,
                    error: true
                });
                else setPluggableItems({
                    data: $7ebfaf39895f9303$var$transform(forgeModules[0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE], connectResponse.data?.jiraWebSection?.webItems?.nodes, intlCollator.compare),
                    loading: false,
                    error: false
                });
            }).catch(()=>{
                setPluggableItems({
                    data: null,
                    loading: false,
                    error: true
                });
            });
            lastKeyRef.current = currentKeyRef.current;
        }
    }, [
        cloudId,
        isAnonymous,
        intlCollator.compare,
        lastKeyRef,
        setPluggableItems
    ]);
    // Sync this to avoid recreating the callback and mitigating rerender
    currentKeyRef.current = key;
    return (0, $eJOHy.useMemo)(()=>[
            fetchPluggableItems,
            pluggableItems
        ], [
        pluggableItems,
        fetchPluggableItems
    ]);
};
const $7ebfaf39895f9303$export$774a4ee00eaf0f75 = {
    data: undefined,
    loading: false,
    error: false
};
function $7ebfaf39895f9303$var$transform(forgeModules, connectModules, comparator) {
    return [
        ...forgeModules.map((module)=>{
            return {
                type: 'forge',
                id: module.id,
                title: module.properties.title,
                iconUrl: module.properties.icon ?? null,
                tooltip: module.properties.tooltip ?? null,
                metadata: module
            };
        }),
        ...connectModules.filter((item)=>item.label != null).map((module)=>({
                type: 'connect',
                id: module.id,
                title: module.label || '',
                iconUrl: module.iconUrl,
                tooltip: module.tooltip,
                metadata: module
            }))
    ].sort((a, b)=>comparator(a.title, b.title));
}

});
parcelRegister("gfDeC", function(module, exports) {

$parcel$export(module.exports, "PluggableItemsCacheContext", () => $84e95ca7fc7a04c7$export$884805f5de744f77);
$parcel$export(module.exports, "PluggableItemsCacheProvider", () => $84e95ca7fc7a04c7$export$f2618be54b96efae);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $84e95ca7fc7a04c7$var$initialResponse = {
    data: undefined,
    loading: false,
    error: false
};
const $84e95ca7fc7a04c7$export$884805f5de744f77 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    pluggableItems: $84e95ca7fc7a04c7$var$initialResponse,
    setPluggableItems: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    lastKeyRef: {
        current: undefined
    }
});
const $84e95ca7fc7a04c7$export$f2618be54b96efae = ({ onDataChanged: onDataChanged, children: children })=>{
    const [pluggableItems, setPluggableItemsBase] = (0, $eJOHy.useState)($84e95ca7fc7a04c7$var$initialResponse);
    const lastKeyRef = (0, $eJOHy.useRef)(undefined);
    const setPluggableItems = (0, $eJOHy.useCallback)((newPluggableItems)=>{
        setPluggableItemsBase(newPluggableItems);
        onDataChanged();
    }, [
        onDataChanged
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            pluggableItems: pluggableItems,
            setPluggableItems: setPluggableItems,
            lastKeyRef: lastKeyRef
        }), [
        pluggableItems,
        setPluggableItems,
        lastKeyRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84e95ca7fc7a04c7$export$884805f5de744f77.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("j1JBz", function(module, exports) {

$parcel$export(module.exports, "ISSUE_NAVIGATOR_PLUGGABLE_ITEMS_QUERY", () => $01741719a7ff3c10$export$832447adf89352b6);

var $l6Jfp = parcelRequire("l6Jfp");
const $01741719a7ff3c10$export$832447adf89352b6 = (0, $l6Jfp.gqlTagGira)`
  query IssueNavigatorPluggableItemsQuery($first: Int!) {
    jiraWebSection(input: { location: JIRA_NAVIGATOR }) {
      webItems(first: $first) {
        pageInfo {
          hasNextPage
        }
        totalCount
        nodes {
          id
          label
          tooltip
          iconUrl
          target {
            type
            addonKey
            moduleKey
            ...on JiraWebItemTargetDialogModule {
              targetKey
            }
          }
        }
      }
    }
  }
`;

});
parcelRegister("l6Jfp", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $bba965161d9cb764$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $bba965161d9cb764$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $bba965161d9cb764$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $bba965161d9cb764$export$c46d621c29194aa4 = 5;
const $bba965161d9cb764$export$304a6c004edb30d8 = '-created';
const $bba965161d9cb764$export$b2e398ce246f55b3 = 5;
const $bba965161d9cb764$export$1c36ecc9afd61c73 = '-started';
const $bba965161d9cb764$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});



parcelRegister("aWMnb", function(module, exports) {

$parcel$export(module.exports, "useModalDialogCleanupEffect", () => $bedb1e8370874adf$export$586cda8757903229);
$parcel$export(module.exports, "useRegisterModalDialogAnalytics", () => $bedb1e8370874adf$export$fc10f874e8bd1adc);
$parcel$export(module.exports, "useInlineDialogZIndexOverrideLayoutEffect", () => $bedb1e8370874adf$export$84648db9790b0ee);

var $eJOHy = parcelRequire("eJOHy");

var $8sbs2 = parcelRequire("8sbs2");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");
const $bedb1e8370874adf$export$34bf1befb2fab61a = ()=>window.connectHost?.dialog?.close();
const $bedb1e8370874adf$export$cf40ddca756b7741 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const topEl = window.AJS?.LayerManager?.global?.getTopLayer();
    if (topEl == null) return null;
    return topEl.find('iframe')?.[0];
};
const $bedb1e8370874adf$export$586cda8757903229 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useEffect)(()=>()=>{
            try {
                const dialogBeforeClose = $bedb1e8370874adf$export$cf40ddca756b7741();
                $bedb1e8370874adf$export$34bf1befb2fab61a();
                const dialogNow = $bedb1e8370874adf$export$cf40ddca756b7741();
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), dialogBeforeClose && dialogNow ? 'iframe not closed' : 'iframe closed', 'apps', {
                    // Match the unique key part separated by a final __ delimination
                    uniqueKey: dialogBeforeClose?.id.match(/.*(?=__)/)?.[0] ?? dialogBeforeClose?.id,
                    uniqueOpenKey: dialogNow?.id.match(/.*(?=__)/)?.[0] ?? dialogNow?.id
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gYnSx.default)({
                    error: error,
                    meta: {
                        id: 'issue-navigator-action-pluggable-items.ui.useModalDialogCleanupEffect',
                        packageName: 'jiraIssueNavigatorActionPluggableItems',
                        teamName: 'empanada'
                    }
                });
            }
        }, [
        createAnalyticsEvent
    ]);
};
const $bedb1e8370874adf$export$fc10f874e8bd1adc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const iFrameEstablishedCallback = (0, $eJOHy.useCallback)((payload)=>{
        if (payload.extension.options.moduleType === 'dialogs') (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'iframe established', 'apps', (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(payload.extension.options, [
            'addon_key',
            'isDialog',
            'dialogId',
            'isFullPage',
            'uniqueKey',
            'origin'
        ]));
    }, [
        createAnalyticsEvent
    ]);
    const timeoutIdRef = (0, $eJOHy.useRef)();
    const registerListeners = (0, $eJOHy.useCallback)(()=>{
        // Connect doesn't seem to have a way to notify when it has been registered, so we have to resort to polling
        timeoutIdRef.current = setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (!window.connectHost) registerListeners();
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.connectHost.onIframeEstablished(iFrameEstablishedCallback);
        }, 1000);
    }, [
        iFrameEstablishedCallback
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>()=>{
            clearTimeout(timeoutIdRef.current);
            // @ts-expect-error - TS2339 - Unsafe use of Connect's internal API
            if (iFrameEstablishedCallback._wrapper != null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.connectHost?.offIframeEstablished(iFrameEstablishedCallback);
            timeoutIdRef.current = undefined;
        }, [
        iFrameEstablishedCallback,
        registerListeners
    ]);
    return ()=>{
        if (timeoutIdRef.current === undefined) registerListeners();
    };
};
const $bedb1e8370874adf$export$84648db9790b0ee = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { current: styleNode } = (0, $eJOHy.useRef)(document.createElement('style'));
    (0, $eJOHy.useLayoutEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(styleNode);
        styleNode.setAttribute('data-nin-pluggable-items', 'css');
        styleNode.sheet?.insertRule('div.aui-inline-dialog[id^="inline-dialog-webitem-"]{z-index:401}', 0);
        return ()=>{
            if ((0, $7jTnu.fg)('empanada_nin_fix_apps_removechild_error')) styleNode.remove();
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.head?.removeChild(styleNode);
        };
    }, [
        styleNode
    ]);
};

});

parcelRegister("bqs8h", function(module, exports) {

$parcel$export(module.exports, "ACTIONS_MIN_WIDTH", () => $a7a3171f30021cf8$export$6136614e7d9538ed);
$parcel$export(module.exports, "CONTAINER_MIN_WIDTH", () => $a7a3171f30021cf8$export$23f5cd335b4ac583);

var $dPMMf = parcelRequire("dPMMf");
const $a7a3171f30021cf8$export$6136614e7d9538ed = (0, $dPMMf.gridSize) * 25; // 200
const $a7a3171f30021cf8$export$23f5cd335b4ac583 = (0, $dPMMf.gridSize) * 30; // 240

});

parcelRegister("5ZkD9", function(module, exports) {

$parcel$export(module.exports, "DropdownItemWithApps", () => $f51378283640a5eb$export$6d69d82af462f986);

var $eJOHy = parcelRequire("eJOHy");

var $4R324 = parcelRequire("4R324");

var $lkRD7 = parcelRequire("lkRD7");
const $f51378283640a5eb$export$6d69d82af462f986 = (props)=>{
    if ($f51378283640a5eb$var$isForgeProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lkRD7.ForgeDropdownItemWithErrorBoundary), props);
    if ($f51378283640a5eb$var$isConnectProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4R324.ConnectDropdownItem), props);
    return null;
};
function $f51378283640a5eb$var$isForgeProps(props) {
    return props.item.type === 'forge';
}
function $f51378283640a5eb$var$isConnectProps(props) {
    return props.item.type === 'connect';
}

});
parcelRegister("4R324", function(module, exports) {

$parcel$export(module.exports, "ConnectDropdownItem", () => $4827d00c5640a14e$export$e253d0820bea0fd6);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8rSHB = parcelRequire("8rSHB");

var $gv7Fx = parcelRequire("gv7Fx");
const $4827d00c5640a14e$export$e253d0820bea0fd6 = ({ item: item, totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4827d00c5640a14e$export$c0117b1abc6c64e3, {
        testId: "issue-navigator-action-pluggable-items.ui.dropdown-item.connect-dropdown-item.drop-down-item",
        key: item.id,
        id: item.id ?? undefined,
        title: typeof item.tooltip === 'string' ? item.tooltip : undefined,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gv7Fx.AppIcon), {
            iconUrl: item.iconUrl
        }),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: item.metadata.target && (0, $8rSHB.buildStyleClass)(item.metadata.target) || '',
        analyticsAppCount: totalCount,
        analyticsAppName: item.title ?? '',
        analyticsAppType: (0, $8rSHB.translateAppTypeToAnalyticsType)(item.metadata.target?.type)
    }, item.title);
function $4827d00c5640a14e$export$c0117b1abc6c64e3({ analyticsAppName: analyticsAppName, analyticsAppCount: analyticsAppCount, analyticsAppType: analyticsAppType, testId: testId, ...props }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireDropdownClickUIAnalytics = (0, $eJOHy.useCallback)((event)=>{
        if ('key' in event && event.key != null && event.key !== 'Enter' && event.key !== ' ') return;
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'apps', {
            uniqueKey: props.id,
            source: 'key' in event ? 'keypress' : 'click',
            appCount: analyticsAppCount,
            appName: analyticsAppName,
            appType: analyticsAppType
        });
    }, [
        analyticsAppCount,
        analyticsAppName,
        analyticsAppType,
        createAnalyticsEvent,
        props.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        ...props,
        onClick: fireDropdownClickUIAnalytics,
        testId: testId
    });
}

});
parcelRegister("8rSHB", function(module, exports) {

$parcel$export(module.exports, "buildStyleClass", () => $bea33e9d4c5de920$export$f8c1d825aaa31bf2);
$parcel$export(module.exports, "isInOrIsIFrame", () => $bea33e9d4c5de920$export$5f8a28ced7cd3069);
$parcel$export(module.exports, "translateAppTypeToAnalyticsType", () => $bea33e9d4c5de920$export$7beec86e5c4555f8);
const $bea33e9d4c5de920$export$f8c1d825aaa31bf2 = (target)=>{
    const classes = [];
    switch(target.type){
        case 'DIALOG':
            classes.push('ap-dialog');
            break;
        case 'DIALOG_MODULE':
            classes.push('ap-dialog');
            if ('targetKey' in target && target.targetKey != null) classes.push(`ap-target-key-${target.targetKey}`);
            break;
        case 'INLINE_DIALOG':
            classes.push('ap-inline-dialog');
            break;
        default:
            break;
    }
    if (target.addonKey != null) classes.push(`ap-plugin-key-${target.addonKey}`);
    if (target.moduleKey != null) classes.push(`ap-module-key-${target.moduleKey}`);
    return classes.join(' ');
};
const $bea33e9d4c5de920$export$5f8a28ced7cd3069 = (element, idLooseMatchList)=>{
    const isIFrameWithMatchingId = element.nodeName === 'IFRAME' && !!idLooseMatchList.find((id)=>element.id.match(id));
    const isDifferentOwnerDocument = element.ownerDocument !== document;
    return isIFrameWithMatchingId || isDifferentOwnerDocument;
};
const $bea33e9d4c5de920$export$7beec86e5c4555f8 = (type)=>{
    switch(type){
        case 'DIALOG':
            return 'dialog';
        case 'DIALOG_MODULE':
            return 'dialog_module';
        case 'INLINE_DIALOG':
            return 'inline_dialog';
        default:
            return 'unknown';
    }
};

});

parcelRegister("gv7Fx", function(module, exports) {

$parcel$export(module.exports, "AppIcon", () => $8a7063b1bb28cbc9$export$5153830bdfb71453);

var $eJOHy = parcelRequire("eJOHy");

var $f9wiC = parcelRequire("f9wiC");

var $aNxjx = parcelRequire("aNxjx");
const $8a7063b1bb28cbc9$export$5153830bdfb71453 = ({ iconUrl: iconUrl })=>{
    return iconUrl != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNxjx.IconCustom), {
        shouldChangeFillColor: false,
        url: iconUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f9wiC))), {
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: "",
        testId: "issue-navigator-action-pluggable-items.ui.dropdown-item.app-icon.default-icon"
    });
};

});


parcelRegister("lkRD7", function(module, exports) {

$parcel$export(module.exports, "ForgeDropdownItemWithErrorBoundary", () => $d35d2c953b766993$export$f593ef049d8ab980);

var $eJOHy = parcelRequire("eJOHy");

var $dB1eP = parcelRequire("dB1eP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $h47gY = parcelRequire("h47gY");

var $9F3VB = parcelRequire("9F3VB");

var $aeOhE = parcelRequire("aeOhE");

var $52lsd = parcelRequire("52lsd");

var $iqd0x = parcelRequire("iqd0x");

var $jZxkB = parcelRequire("jZxkB");

var $74bkD = parcelRequire("74bkD");

var $1wL9i = parcelRequire("1wL9i");

var $fwKw5 = parcelRequire("fwKw5");

var $bqs8h = parcelRequire("bqs8h");

var $gv7Fx = parcelRequire("gv7Fx");
const $d35d2c953b766993$export$f593ef049d8ab980 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        packageName: "software",
        id: "forge-dropdown-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d35d2c953b766993$export$df33c67d25a78185, props));
};
function $d35d2c953b766993$export$df33c67d25a78185({ item: item, totalCount: totalCount }) {
    const jql = (0, $fwKw5.useResolvedJql)();
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const issueKey = (0, $1wL9i.useSelectedIssueKey)();
    const issueNavigatorData = (0, $eJOHy.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            issueKeys: issueKey ? [
                issueKey
            ] : []
        }), [
        jql,
        filterId,
        issueKey
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $74bkD.ExtensionTitle), {
            extensionName: item.title,
            extensionEnvType: item.metadata.environmentType,
            extensionEnvKey: item.metadata.environmentKey,
            autoTruncate: true
        });
    }, [
        item.metadata.environmentKey,
        item.metadata.environmentType,
        item.title
    ]);
    return item.metadata.properties.actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d35d2c953b766993$var$ForgeDropdownItemWithActions, {
        item: item,
        totalCount: totalCount,
        issueNavigatorData: issueNavigatorData,
        title: title
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d35d2c953b766993$var$ForgeDropdownItemSimple, {
        item: item,
        totalCount: totalCount,
        issueNavigatorData: issueNavigatorData,
        title: title
    });
}
function $d35d2c953b766993$var$ForgeDropdownItemSimple({ item: item, totalCount: totalCount, issueNavigatorData: issueNavigatorData, title: title }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d35d2c953b766993$export$c0117b1abc6c64e3, {
        key: item.id,
        itemType: "forge-app",
        testId: "issue-navigator-action-pluggable-items.ui.dropdown-item.forge-dropdown-item.action-drop-down-item",
        item: item,
        totalCount: totalCount,
        issueNavigatorData: issueNavigatorData,
        tooltip: typeof item.tooltip === 'string' ? item.tooltip : undefined,
        title: title
    }));
}
function $d35d2c953b766993$var$ForgeDropdownItemWithActions({ item: item, totalCount: totalCount, issueNavigatorData: issueNavigatorData, title: title }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        key: item.id,
        placement: "right-start",
        shouldFlip: true,
        spacing: "compact",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
                ...triggerProps,
                ref: triggerRef,
                title: typeof item.tooltip === 'string' ? item.tooltip : undefined,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gv7Fx.AppIcon), {
                    iconUrl: item.iconUrl
                }),
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
                    spacing: "spacious",
                    color: "var(--ds-icon-subtle, #626F86)",
                    label: "",
                    size: "small"
                })
            }, title),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d35d2c953b766993$var$actionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, (item.metadata.properties.actions ?? []).map((action)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d35d2c953b766993$export$c0117b1abc6c64e3, {
            key: `${item.id}${action.key}`,
            itemType: "forge-action",
            testId: "issue-navigator-action-pluggable-items.ui.dropdown-item.forge-dropdown-item.action-drop-down-item",
            item: item,
            action: action,
            totalCount: totalCount,
            issueNavigatorData: issueNavigatorData,
            tooltip: typeof action.tooltip === 'string' ? action.tooltip : undefined,
            title: action.title
        });
    }))));
}
function $d35d2c953b766993$export$c0117b1abc6c64e3(props) {
    const { totalCount: totalCount, itemType: itemType, item: item, action: action } = props;
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            ...(0, $52lsd.getAnalyticsAttributesFromExtension)(item.metadata),
            analyticsAppName: item.title,
            analyticsActionName: action?.title,
            analyticsAppCount: totalCount,
            analyticsAppType: itemType,
            source: 'issue-navigator'
        }), [
        action?.title,
        item.metadata,
        item.title,
        itemType,
        totalCount
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        (0, $iqd0x.fireUiTriggerClickedEvent)(item.id, 'issue-navigator', analyticsAttributes);
    }, [
        analyticsAttributes,
        item.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZxkB.TriggerAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d35d2c953b766993$var$DropdownItemInner, {
        ...props,
        onClick: handleOnClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: analyticsAttributes
    }));
}
function $d35d2c953b766993$var$DropdownItemInner({ totalCount: totalCount, itemType: itemType, testId: testId, item: item, title: title, action: action, issueNavigatorData: issueNavigatorData, onClick: onClick, tooltip: tooltip, ...props }) {
    const [isAppLoading] = (0, $9F3VB.useIsAppLoading)({
        appId: item.id,
        action: action?.key
    });
    const [, { openApp: openApp }] = (0, $9F3VB.useForgeApps)();
    const handleOnClick = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
        onClick();
        openApp(item.id, item.metadata, action?.key, {
            ...issueNavigatorData,
            action: action?.key
        });
    }, [
        action?.key,
        issueNavigatorData,
        item.id,
        item.metadata,
        onClick,
        openApp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        ...props,
        title: tooltip,
        onClick: handleOnClick,
        testId: testId,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d35d2c953b766993$var$LoadingIndicator, {
            isAppLoading: isAppLoading
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gv7Fx.AppIcon), {
            iconUrl: item.iconUrl
        })
    }, title);
}
function $d35d2c953b766993$var$LoadingIndicator({ isAppLoading: isAppLoading }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d35d2c953b766993$var$indicatorStyle
    }, isAppLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    }));
}
const $d35d2c953b766993$var$indicatorStyle = (0, $1DXK0.xcss)({
    width: "var(--ds-space-150, 12px)"
});
const $d35d2c953b766993$var$actionsContainerStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $bqs8h.ACTIONS_MIN_WIDTH)}px`
});

});
parcelRegister("iqd0x", function(module, exports) {

$parcel$export(module.exports, "fireUiTriggerClickedEvent", () => $2070c848182c8704$export$cc0cc6563e35ae9);

var $fohjD = parcelRequire("fohjD");

var $1GZq2 = parcelRequire("1GZq2");

var $ibOCX = parcelRequire("ibOCX");

var $lHD3D = parcelRequire("lHD3D");

var $9gq2c = parcelRequire("9gq2c");

var $7jTnu = parcelRequire("7jTnu");
const $2070c848182c8704$var$triggerEventId = (0, $ibOCX.getEventIdOld)({
    module: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
    moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER)
});
const $2070c848182c8704$export$cc0cc6563e35ae9 = (extensionId, source, attributes)=>{
    (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $1GZq2.fireUiEvent)((0, $9gq2c.UI_ACTIONS).CLICKED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER)
        }) : $2070c848182c8704$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};

});

parcelRegister("jZxkB", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $bcffe6cc661d295e$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $bcffe6cc661d295e$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $bcffe6cc661d295e$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
        ...props
    });
const $bcffe6cc661d295e$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
        ...props
    });

});



parcelRegister("5Iesg", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $c7adaccfee4b64dd$export$1f74963c34e8bfec);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $adVJq = parcelRequire("adVJq");

var $lRq8t = parcelRequire("lRq8t");

var $8w1BJ = parcelRequire("8w1BJ");
const $c7adaccfee4b64dd$export$1f74963c34e8bfec = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7adaccfee4b64dd$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c7adaccfee4b64dd$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $adVJq.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7adaccfee4b64dd$var$P, null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $8w1BJ.default).emptyIssueTerminologyRefreshM4 : (0, $8w1BJ.default).empty)));
};
const $c7adaccfee4b64dd$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    height: '72px',
    width: '72px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7adaccfee4b64dd$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4 _19pku2gc _2hwxutpp _otyru2gc _18u0utpp _vwz47vkz",
            __cmplp.className
        ])
    });
});
const $c7adaccfee4b64dd$var$P = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5724jg8 _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("adVJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c56b1f234f7d4ec$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("2JjKy")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("2JjKy")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nj3nrg7zrmxwrhh9fn9ftw5m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nj3nrg7zrmxwrhh9fn9ftw5m

var $c4huj = parcelRequire("c4huj");

var $2JjKy = parcelRequire("2JjKy");
const $3c56b1f234f7d4ec$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2JjKy)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2JjKy))
});
var $3c56b1f234f7d4ec$export$2e2bcd8739ae039 = $3c56b1f234f7d4ec$var$Illustration;
// for advanced use only
const $3c56b1f234f7d4ec$export$a179c88182cb9d56 = [
    0,
    0,
    95,
    89
];

});
parcelRegister("2JjKy", function(module, exports) {
module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();

});


parcelRegister("8w1BJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $487932099e92e1c4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $487932099e92e1c4$var$messages = (0, $7qGN1.defineMessages)({
    empty: {
        "id": "issue-navigator-action-pluggable-items.empty.empty",
        "defaultMessage": "There are no apps installed for the Issue Navigator"
    },
    emptyIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-pluggable-items.empty.empty-issue-terminology-refresh-m4",
        "defaultMessage": "There are no apps installed for the work item search"
    }
});
var $487932099e92e1c4$export$2e2bcd8739ae039 = $487932099e92e1c4$var$messages;

});


parcelRegister("lqBEF", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorActionRuntimeContainer", () => $7e12de990d786a5c$export$7b26d9e8e90b5c69);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $baJzF = parcelRequire("baJzF");

var $52lsd = parcelRequire("52lsd");

var $jZxkB = parcelRequire("jZxkB");

var $lgPrm = parcelRequire("lgPrm");
const $7e12de990d786a5c$export$cfffe81d508bcda3 = ({ app: app, setLoaded: setLoaded, localId: localId, handleError: baseHandleError, closeApp: closeApp })=>{
    // TO DO: add handling for app timeout
    // https://ecosystem-platform.atlassian.net/browse/ARKEN-1786
    // Force render the default error message (instead of the content from the error).
    // By default baseHandleError accepts error message as a parameter
    const handleError = (0, $eJOHy.useCallback)(()=>{
        baseHandleError && baseHandleError();
    }, [
        baseHandleError
    ]);
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            ...(0, $52lsd.getAnalyticsAttributesFromExtension)(app.extension),
            source: 'issue-navigator'
        }), [
        app.extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZxkB.ViewAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgPrm.AsyncIssueNavigatorAction), {
        localId: localId,
        extensionData: app.extensionData,
        extension: app.extension,
        analyticsAttributes: analyticsAttributes,
        onLoad: setLoaded,
        onInitialRender: setLoaded,
        onError: handleError,
        onClose: closeApp
    }));
};
const $7e12de990d786a5c$export$7b26d9e8e90b5c69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        packageName: "software",
        id: "forge-issue-navigator-action-runtime-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $baJzF.ForgeAppsRuntimeContainer), {
        forgeAppRenderer: $7e12de990d786a5c$export$cfffe81d508bcda3
    }));

});
parcelRegister("baJzF", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsRuntimeContainer", () => $09e0d61538a81ace$export$db56fac1456ccba8);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $iiemF = parcelRequire("iiemF");

var $lRq8t = parcelRequire("lRq8t");

var $9F3VB = parcelRequire("9F3VB");

var $hO2PV = parcelRequire("hO2PV");
const $09e0d61538a81ace$var$toTargetForgeApp = (app)=>{
    return {
        id: app.id,
        extension: app.extension,
        extensionData: app.action ? {
            ...app.extensionData,
            action: app.action
        } : app.extensionData
    };
};
const $09e0d61538a81ace$var$BaseForgeAppRenderer = ({ app: app, setAppLoaded: setAppLoaded, setAppClose: setAppClose, renderer: ForgeAppRendererComponent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const localId = app.extensionData.action ? `${app.id},action:${app.extensionData.action}` : app.id;
    const setLoaded = (0, $eJOHy.useCallback)(()=>{
        app.isLoading && setAppLoaded(app.id, app.action);
    }, [
        app.id,
        app.action,
        app.isLoading,
        setAppLoaded
    ]);
    const closeApp = (0, $eJOHy.useCallback)(()=>{
        setAppClose(app.id, app.action);
    }, [
        app.id,
        app.action,
        setAppClose
    ]);
    const targetApp = (0, $eJOHy.useMemo)(()=>$09e0d61538a81ace$var$toTargetForgeApp(app), [
        app
    ]);
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const handleError = (0, $eJOHy.useCallback)((msg)=>{
        showFlag({
            key: localId,
            type: 'error',
            title: formatMessage((0, $hO2PV.messages).appErrorTitle),
            description: msg ?? formatMessage((0, $hO2PV.messages).appErrorDescription),
            messageId: 'forge-action-apps-controller.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        localId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ForgeAppRendererComponent, {
        localId: localId,
        app: targetApp,
        setLoaded: setLoaded,
        closeApp: closeApp,
        isLoading: app.isLoading,
        handleError: handleError
    });
};
const $09e0d61538a81ace$export$db56fac1456ccba8 = ({ forgeAppRenderer: forgeAppRenderer })=>{
    const [{ openedApps: openedApps }, { setAppLoaded: setAppLoaded, closeApps: closeApps, closeApp: closeApp }] = (0, $9F3VB.useForgeApps)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            closeApps();
        };
    }, [
        closeApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iiemF.InvisibleDiv), null, openedApps.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09e0d61538a81ace$var$BaseForgeAppRenderer, {
            key: app.uuid,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            app: app,
            setAppLoaded: setAppLoaded,
            setAppClose: closeApp,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            renderer: forgeAppRenderer
        })));
};

});
parcelRegister("iiemF", function(module, exports) {

$parcel$export(module.exports, "InvisibleDiv", () => $f7376740d95fd4fa$export$22ef238a7bbeac70);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f7376740d95fd4fa$export$22ef238a7bbeac70 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $f7376740d95fd4fa$export$1442582cffa6fcb7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hO2PV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $09a3dd4827d75799$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $09a3dd4827d75799$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    appErrorTitle: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-title",
        "defaultMessage": "App Error"
    },
    appErrorDescription: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-description",
        "defaultMessage": "An error occurred while loading the app"
    }
});

});


parcelRegister("lgPrm", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueNavigatorAction", () => $741e176bbe039316$export$972ed080d6cd6f83);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $av1az = parcelRequire("av1az");

var $ch9En = parcelRequire("ch9En");

var $9W4iD = parcelRequire("9W4iD");
const $741e176bbe039316$export$c83cb1d538aeaee0 = (props)=>{
    const { extension: extension, extensionData: extensionData, ...restProps } = props;
    const extensionDataValue = (0, $eJOHy.useMemo)(()=>({
            ...extensionData,
            type: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $eJOHy.useMemo)(()=>({
            module: (0, $fohjD.ISSUE_NAVIGATOR_ACTION_MODULE),
            extensionData: extensionDataValue,
            extension: extension,
            contextToken: (0, $fohjD.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extension,
        extensionDataValue
    ]);
    const bridge = (0, $eJOHy.useMemo)(()=>({
            close: props.onClose
        }), [
        props.onClose
    ]);
    if ((0, $av1az.isNativeUiExtension)(extension) || (0, $av1az.isCustomUIExtension)(extension)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.PlaceholderUFOMigration), {
        name: "issue-navigator-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9W4iD.LazyIssueNavigatorForgeExtension), {
        ...restProps,
        ...extraProps,
        bridge: bridge,
        hasModalConsentPrompt: true
    }));
    return null;
};
const $741e176bbe039316$export$972ed080d6cd6f83 = $741e176bbe039316$export$c83cb1d538aeaee0;

});
parcelRegister("9W4iD", function(module, exports) {

$parcel$export(module.exports, "LazyIssueNavigatorForgeExtension", () => $e59a384a326d775a$export$6a4f9722384892ff);

var $aeOhE = parcelRequire("aeOhE");

var $bQWwW = parcelRequire("bQWwW");

const $e59a384a326d775a$var$getModule = ()=>(parcelRequire("knC5L"));
const $e59a384a326d775a$export$6a4f9722384892ff = (0, $aeOhE.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyForPaint)(()=>$e59a384a326d775a$var$getModule().then((module)=>module.IssueNavigatorForgeExtension), {
    ssr: false
}));

});
parcelRegister("knC5L", function(module, exports) {

let $ed6380e6575b3252$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ed6380e6575b3252$var$load("3yAl4"),
    $ed6380e6575b3252$var$load("kNFvF"),
    $ed6380e6575b3252$var$load("76n7a"),
    $ed6380e6575b3252$var$load("l253H"),
    $ed6380e6575b3252$var$load("ffQaD"),
    $ed6380e6575b3252$var$load("kvRbA"),
    $ed6380e6575b3252$var$load("1CwLt")
]).then(()=>parcelRequire('fkhtA'));

});






//# sourceMappingURL=async-pluggable-items.6e603a0d.js.map
